import Header from "../../components/header";
import { Container, HeaderSection, ListContainer } from "../style";
import CreateBoardModal from "../../components/modals/createBoardModal";
import UserInfoCard from "../../components/dashboardSections/userInfoCard";
import { CircularProgress, Stack, Grid, Typography, Box } from "@mui/material";
import DownloadExtensionCard from "../../components/dashboardSections/downloadExtensionCard";
import SwipeAdSection from "../../components/dashboardSections/swipeAdSection";
import ExploreLoungeSection from "../../components/dashboardSections/exploreLoungeSection";
import TranscriptLoungeSection from "../../components/dashboardSections/transcriptSection";
import LearnSwipeLoungeSection from "../../components/dashboardSections/learnSwipeLoungeSection";
import ContactUsSection from "../../components/dashboardSections/contactUsSection";
import { useSelector } from "react-redux";
import {
  DashoardAnalyticsSaga,
  DashoardAnalyticsSagaName,
} from "../../store/dashboardAnalytics/sagas";
import {
  DashoardAnalyticsReducer,
  DashoardAnalyticsReducerName,
} from "../../store/dashboardAnalytics/slice";
import {
  dashboardAnalyticsSelector,
  dashboardLoadingSelector,
} from "../../store/dashboardAnalytics/selector";
import OpenViewFolderModal from "../../components/modals/openViewFolderModal";
import CreateTeamModal from "../../components/modals/createTeamModal";
import SubscriptionPlansSection from "../../components/dashboardSections/subscriptionPlansSection";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { userDetailsSelector } from "../../store/account/selector";
import { TeamIcon } from "../../assets/Icons";
import { CardContainer } from "../../components/dashboardSections/style";

const content = {
  tabTitle: "Dashboard",
  tabSubTitle: "Your Creative Strategy Hub",
};

const Dashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const userDetails = useSelector(userDetailsSelector);
  const dashboardLoading = useSelector(dashboardLoadingSelector);
  useInjectReducer({
    reducer: DashoardAnalyticsReducer,
    key: DashoardAnalyticsReducerName,
  });

  useInjectSaga({
    saga: DashoardAnalyticsSaga,
    key: DashoardAnalyticsSagaName,
  });

  const dashboardAnalytics = useSelector(dashboardAnalyticsSelector);

  useEffect(() => {
    const shouldScroll = location.state?.scrollToContactUs;
    if (shouldScroll && dashboardAnalytics?.userActivePlan?.name) {
      const tryScroll = () => {
        const contactEle = document.querySelector(".contact-us-container");
        if (contactEle) {
          contactEle.scrollIntoView({ behavior: "smooth" });

          const contactNameEle = document.querySelector(
            ".contact-form-name input"
          ) as HTMLInputElement;
          contactNameEle?.focus();

          navigate(location.pathname, { replace: true, state: {} });

          return true;
        }
        return false;
      };

      const interval = setInterval(() => {
        const success = tryScroll();
        if (success) clearInterval(interval);
      }, 200);

      setTimeout(() => clearInterval(interval), 5000);
    }
  }, [location.state?.scrollToContactUs, dashboardAnalytics]);

  return (
    <Container>
      <HeaderSection>
        <Header content={content} />
        <ListContainer display={"flex"} flexDirection={"column"} gap="1.875rem">
          {!userDetails || dashboardLoading   ? (
            <CircularProgress sx={{ placeSelf: "center" }} />
          ) : (
            <>
              <Stack direction="row" gap="1.875rem">
                <UserInfoCard />
                <DownloadExtensionCard />
              </Stack>
              <Grid container spacing={"1.875rem"}>
                {/* Left Side (Plan or Invited Message) */}
                <Grid
                  item
                  sm={6}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    flexGrow: 1,
                  }}
                >
                  {userDetails?.planId ? (
                    <SubscriptionPlansSection />
                  ) : (
                    <CardContainer
                      sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        p: "2rem 1.5rem",
                        gap: "1rem",
                      }}
                    >
                      {/* Icon */}
                      <Box
                        sx={{
                          width: "3.5rem",
                          height: "3.5rem",
                          borderRadius: "50%",
                          background: (theme) => theme.palette.grey[100],
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <TeamIcon />
                      </Box>

                      {/* Title */}
                      <Typography
                        fontSize="1.2rem"
                        fontWeight="700"
                        color="text.primary"
                      >
                        You’re part of a workspace
                      </Typography>

                      {/* Subtext */}
                      <Typography
                        fontSize="0.95rem"
                        color="text.secondary"
                        maxWidth="20rem"
                      >
                        Your subscription is managed by the workspace owner
                      </Typography>

                      {/* Owner Info */}
                      <Box
                        sx={{
                          mt: "0.75rem",
                          p: "1rem 1.25rem",
                          borderRadius: "0.75rem",
                          background: (theme) => theme.palette.grey[50],
                          border: "1px solid",
                          borderColor: (theme) => theme.palette.grey[200],
                          boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                          minWidth: "15rem",
                        }}
                      >
                        <Typography
                          fontSize="1rem"
                          fontWeight="600"
                          color="text.primary"
                          mb="0.25rem"
                        >
                          {userDetails?.parentPlanDetails?.parentDeatils
                            ?.fullName || "Workspace Owner"}
                        </Typography>
                        <Typography
                          fontSize="0.9rem"
                          color="text.secondary"
                          component="a"
                          href={`mailto:${
                            userDetails?.parentPlanDetails?.parentDeatils
                              ?.email || ""
                          }`}
                          sx={{ textDecoration: "none", color: "inherit" }}
                        >
                          {userDetails?.parentPlanDetails?.parentDeatils
                            ?.email || "owner@email.com"}
                        </Typography>
                      </Box>
                    </CardContainer>
                  )}
                </Grid>

                {/* Right Side (Learn Section) */}
                <Grid
                  item
                  sm={6}
                  sx={{ display: "flex", flexDirection: "column", flexGrow: 1 }}
                >
                  <LearnSwipeLoungeSection />
                </Grid>
              </Grid>
              <SwipeAdSection />
              <ExploreLoungeSection />
              <Stack
                className="contact-us-container"
                direction="row"
                gap="1.875rem"
              >
                <TranscriptLoungeSection />
                <ContactUsSection />
              </Stack>
            </>
          )}
        </ListContainer>
      </HeaderSection>
      <CreateBoardModal />
      <OpenViewFolderModal />
      <CreateTeamModal />
    </Container>
  );
};

export default Dashboard;
